import store from '@/store';
import axios from 'axios';
import authAPI from '@/api/auth';
import settingsAPI from '@/modules/settings/api/settings';
import newSettingsAPI from '@/api/settings';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import Vue from "vue";
import {debug} from '../../settings';
import {local} from '../../settings';
import {local_url} from '../../settings';
import {staging_url} from '../../settings';
import {production_url} from '../../settings';

if(debug === true && local === true){
  axios.defaults.baseURL = local_url;
}else if(debug === true && local === false){
  axios.defaults.baseURL = staging_url;
}else if(debug === false){
  axios.defaults.baseURL = production_url;
  Sentry.init({
    Vue,
    dsn: "https://c7a4676cd6d2497597bf3ebd804e9ace@o383129.ingest.sentry.io/5765339",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  store.dispatch('hasApiError');
  store.dispatch('setApiErrorResponse', error);
  if (error.response.status === 401) {
    console.error(error.response);
    authAPI.logout();
  }
  return Promise.reject(error)
})

export default {
  async setStoreValues () {
    const tok = localStorage.getItem('token');
    if (!tok) {
      return false;
    }
    axios.defaults.headers.common = { 'Authorization': 'Token ' + tok }

    store.dispatch('loadToken', tok);
    store.dispatch('loadProfile', await authAPI.getUserProfile());
    store.dispatch('loadUserID', await authAPI.getUserID());
    store.dispatch('loadUser', await authAPI.getUser(store.state.auth.userid));
    store.dispatch('loadUserApps', await authAPI.getUserApps());
    store.dispatch('loadGlobalOptions', await settingsAPI.getGlobalOptions());
    store.dispatch('loadAccountingSettings', await newSettingsAPI.getAccountingSettings());
    store.dispatch('loadDivisions', await settingsAPI.getDivisions());
    store.dispatch('loadSettings', await settingsAPI.getSettings());
    store.dispatch('loadWOTypes', await settingsAPI.getWOTypes());
    store.dispatch('setRefreshRequired', false);

    return true;
  },
  checkAuth () {
    return this.$store.state.auth.token;
  }
}
